













import Vue from 'vue';
import KitchenSinkTemplate from '@/components/templates/dummy/kitchenSinkTemplate/KitchenSinkTemplate.vue';
import { modelService } from '@/services/form/modelService';
import { rules } from '@/services/form/rules';
import { appConfiguration } from '@/services/form/appConfiguration';
import { FormStepConfiguration } from '@/api/interfaces/configuration/form/base/formStepConfiguration';
import { KitchenSinkForm } from '@/types/forms/dummy/kitchenSinkForm';
import { Validation } from 'vuelidate';
import { ValidationProperties } from 'vue/types/vue';
import SpinnerArea from '@/components/molecules/spinnerArea/SpinnerArea.vue';
import { SpinnerState } from '@/enums/spinnerState';
import router from '@/router';
import { FormContent } from '@/api/interfaces/content/form/formContent';
import { ContentRepository } from '@/api/mock/content/contentRepository';

export default Vue.extend({
    name: 'KitchenSink',
    components: {
        KitchenSinkTemplate,
        SpinnerArea,
    },
    data() {
        return {
            spinner: SpinnerState.opaque,
            content: null as FormContent | null,
            contentLoaded: false,
        };
    },
    computed: {
        model(): KitchenSinkForm {
            return modelService.model.kitchenSink;
        },
        rules(): () => void {
            return rules.kitchenSink;
        },
        validations(): Validation & ValidationProperties<unknown> {
            return modelService.validations.kitchenSink;
        },
        kitchenSinkConfiguration(): unknown {
            return {
                step1: {
                    fields: {
                        fileUpload: ({
                            configurations: [
                                {
                                    type: 'fileUploadConfiguration',
                                    scId: 'kitchenSinkFileUploadGuid',
                                    validations: {
                                        fileTypes: ['pdf'],
                                        maxFileSize: 5242880,
                                    },
                                },
                            ],
                        } as unknown) as FormStepConfiguration,
                    },
                },
            };
        },
    },
    async mounted(): Promise<void> {
        try {
            this.content = await ContentRepository.fetchFormContent();

            this.contentLoaded = !!this.content;
        } catch (error) {
            console.error(error);
            router.push('/fehler');
        }

        appConfiguration.fileUploadConfigurations[
            'kitchenSinkFileUploadGuid'
        ] = {
            fileTypes: ['pdf'],
            maxFileSize: 5242880,
        };
        this.spinner = SpinnerState.off;
    },
});
